'use client'

import { twMerge } from '@/lib/classname/twMerge'
import { SELECT_FIELD_PADDING } from '../select.styles'

type SelectListHeaderProps = {
  message: string
}

/** Non-interactive popover cell, sibling of the search field — not in the ListBox scrollport. */
export function SelectListHeader({ message }: SelectListHeaderProps) {
  return (
    <div
      role="note"
      data-testid="select/header-message"
      className={twMerge(
        'shrink-0 border-b-px border-brand-2-200 bg-brand-2-50 py-1 text-sm font-medium leading-light text-brand-2-700',
        SELECT_FIELD_PADDING,
      )}
    >
      {message}
    </div>
  )
}
